var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 12,
  viewBox: "0 0 10 12",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0, 12) rotate(270 0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1.05445L0 8.94555C2.00025e-05 9.30147 0.193655 9.63335 0.514916 9.82811C0.836176 10.0229 1.24171 10.0542 1.59331 9.91146L11.3175 5.96591C11.732 5.79852 12 5.4192 12 5C12 4.5808 11.732 4.20148 11.3175 4.03409L1.59331 0.0885376C1.24171 -0.0542131 0.836176 -0.0228688 0.514916 0.171888C0.193655 0.366646 2.00025e-05 0.698534 0 1.05445Z",
  fillOpacity: 0.7
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.f77b7efa8bc7a63e77a4fa20c072bba8.svg";